/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/11/10
 * @updateTime 2021/11/10
 * @decription 转换数据mixins方法
 * @namespace 【】
 */
export default {
    // 方法
    methods: {

        /**
         * 获取行数据
         * @param {String} name 名称
         * @param {String|Number} value 值
         * @param {Boolean} wordWrapFlag 是否需要折行
         * @param {Boolean} needToast 是否需要点击提示
         * @returns {Object}
         * */
        getRowData(name, value, wordWrapFlag = false, needToast = false) {
            return {
                name: name,
                value: value,
                wordWrapFlag: wordWrapFlag,
                needToast: needToast
            };
        },

    }
};
